import React from "react";
import { ILineChartData } from "../LineChart/LineChartInterfaces";
import { Box, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { useStyles } from "./LineChartLegends.styles";
import { truncateLongText } from "utilities/utilities";

export const LineChartsLegends = ({ data }: ILineChartData) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Box className={classes.dataContainer}>
                {data.map((item) => (
                    <Box className={classes.failureTypeContainer} key={item.id}>
                        <CircleIcon sx={{ color: item.color }} className={classes.icon} />
                        <Typography variant="h6" className={classes.title}>
                            {truncateLongText(item.id.toString(), 28)}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
